import { useAction } from '@reatom/npm-react'
import { Trans } from 'react-i18next'
import styled from 'styled-components'

import { settingScreenAction, SettingScreenPolicies } from '../atoms'

import { SettingsItem } from './settings-item'

export const SettingsPolicies: React.FC = () => {
  const settingScreen = useAction(settingScreenAction)

  return (
    <Root>
      <Items>
        {SettingScreenPolicies.map((policy) => (
          <SettingsItem
            key={policy}
            title={<Trans i18nKey={`policies.${policy}`} />}
            onClick={() => settingScreen(policy)}
            disabled={false}
          />
        ))}
      </Items>
    </Root>
  )
}

const Root = styled.div``

const Items = styled.div`
  padding: 14px;
  gap: 10px;

  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
`
